import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import Toolbar from 'material-ui-next/Toolbar'
import withStyles from 'material-ui-next/styles/withStyles'
import Search from '../Search'
import breakpoints from '../../../styles/breakpoints'

const styles = theme => ({
  toolbar: {
    ...theme.swapick.styles.toolbars.secondaryToolbar,
    justifyContent: 'flex-end',
    [`@media (max-width: ${breakpoints.xs})`]: {
      justifyContent: 'flex-start',
    },
  },
})

class ItemsToolbar extends PureComponent {
  render() {
    const { location, classes } = this.props
    return (
      <Toolbar className={classes.toolbar}>
        <Search />
      </Toolbar>
    )
  }
}

export default withRouter(withStyles(styles)(ItemsToolbar))



// WEBPACK FOOTER //
// ./src/common/TopBar/SecondaryToolbars/ItemsToolbar.js